import React from 'react';
import {useTheme} from '@mui/material';
import {useLocalization} from 'localization';
import {Layout} from 'components/layout';
import {Text} from 'components/text';

export const EmptyListPlaceholder = () => {
  const {t} = useLocalization();
  const {colors} = useTheme();
  return (
    <Layout pb={0.5}>
      <Text variant="body2" sx={{color: colors.burgundy50}}>
        {t('general.noItems')}
      </Text>
    </Layout>
  );
};
